//
//
//
//
//
//
//
//
//
//
//
//
//

import { getAuthority } from '@/api/yiliaohuzhu'
import { getaddlog } from '@/api/hgfw'
import Storage from '@/storage'
export default {
  data () {
    return {
      isAuth: true,
      search_num: ''
    }
  },
  watch: {
    search_num: function (data) {
      //   console.log(data)
    }
  },
  mounted () {
    this.getAuthorityNow()
    this.addLog()
  },
  computed: {
    accountid () {
      return this.$store.state.user.accountid
    }
  },
  methods: {
    // 浏览量
    addLog () {
      getaddlog({
        accountid: this.accountid,
        moduleid: 1200,
        submoduleid: 120124
      })
    },
    getdatagrid () {
      if (this.search_num.length == 0) {
        this.$vux.toast.text('请输入身份证号！')
      } else {
        console.log(this.search_num)
        this.$router.push({ name: 'yiliaohuzhuInfo', params: { id: this.search_num } })
      }
    },
    getAuthorityNow () {
      // Storage.set('yiliaohuzhu', '/api/exFtuMedicalMutualDeclareinfo/getAuthority.action')
      try {
        getAuthority({
          accountid: this.accountid
        }).then(res => {
          console.log(res)
          if (res.msg == '无权限操作！') {
            this.isAuth = false
            // Storage.set('yiliaohuzhu', '')
          }
        }).catch((e) => {
          console.log(e)
        })
      } catch (err) {
        console.log(e)
      }
    },
    linktowork () {
      this.$router.push({ name: 'yiliaohuzhuWorkspace' })
    }
  }
}
